module.exports = __webpack_public_path__ + "static/media/SDFSA_4-634w.8a546517.jpg";